'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
exports.default = useDebounce;
var React = require('react');
var useDebouncedCallback = require('./callback').default;
function useDebounce(value, delay) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    dispatch = _React$useState2[1];
  var _useDebouncedCallback = useDebouncedCallback(React.useCallback(function (value) {
      return dispatch(value);
    }, []), delay, options),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 2),
    callback = _useDebouncedCallback2[0],
    cancel = _useDebouncedCallback2[1];
  var previousValue = React.useRef(value);
  React.useEffect(function () {
    // We need to use this condition otherwise we will run debounce timer for the first render (including maxWait option)
    if (previousValue.current !== value) {
      callback(value);
      previousValue.current = value;
    }
  }, [value, callback]);
  return [state, cancel];
}